module.exports = __webpack_public_path__ + "img/switzerland-ischemic-heart-disease-male.afbd2159.png";